import { error as logError, warn as logWarn } from '../utils/logger'

export const request_get_advances_api = async () => {
    const URL = `https://api.orqyx.com/v3/apis/oneapp/advances_api`
    const TENANT_ID = `5bfd6878-c559-4131-b740-ed3a6277d441`

    try {
        console.log('Realizando solicitud a get_advances_api...', URL)
        const response = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Tenant-ID': TENANT_ID,
                'If-None-Match': '1',
            },
        })
        if (response.ok) {
            const data = await response.json()

            return data.single
        } else {
            logError(
                'AdvancesService',
                'Error al realizar la solicitud get_advances_api',
            )
            console.log('ERROR EN API ==>', response)
            return null
        }
    } catch (error) {
        logError('AdvanceService', 'get_advances_api error', error)
        return null
    }
}
